// URL Search Params
export const getQueryparams = (search, key) => {
  const query = new URLSearchParams(search);
  return query.get(key);
};

export const formatPhoneNumber = (phoneNumberString) => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
};

export const formatContactNumber = (phNumber, myref) => {
  let cleaned = ("" + phNumber).replace(/\D/g, "");
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let inputString = "(" + match[1] + ") " + match[2] + "-" + match[3];
    myref.current.setFieldValue("phoneNumber", inputString);
  }
};
